var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ApplicationContext',{ref:"context",attrs:{"application":_vm.application,"workspace":_vm.workspace},scopedSlots:_vm._u([{key:"additional-context-items",fn:function(){return [_c('li',{staticClass:"context__menu-item"},[_c('nuxt-link',{staticClass:"context__menu-item-link",attrs:{"to":{
          name: 'database-api-docs-detail',
          params: {
            databaseId: _vm.application.id,
          },
        }}},[_c('i',{staticClass:"context__menu-item-icon iconoir-book"}),_vm._v("\n        "+_vm._s(_vm.$t('sidebar.viewAPI'))+"\n      ")])],1)]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }